<template>
  <AppForm label="上限予算">
    <v-layout
      justify-start
      align-center
      align-content-center
      style="min-height:55px;"
    >
      <v-flex xs6>
        <v-text-field
          v-if="!readonly"
          v-model.number="delivery.budget"
          :disabled="disabled"
          :rules="[rules.greaterThanZero]"
          @change="$emit('change', $event)"
          @keydown.arrow-down.prevent
          @keydown.arrow-up.prevent
          @wheel.prevent
          prepend-icon="￥"
          type="number"
          style="width:100%; max-width:240px;"
          class="pa-0 ma-0"
        />
        <span v-else>{{ delivery.budget }}</span>
      </v-flex>
      <v-flex
        :xs4="showHelp"
        :xs6="!showHelp"
        v-text="message"
        class="error-message"
      />
      <v-flex v-if="showHelp" xs2>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              v-text="'変更する場合'"
              style="background: linear-gradient(transparent 0, #FFE0B2 0); cursor:help;"
            />
          </template>
          <span
            v-text="
              '申請が承認されるのを待つか、申請を一度取り消してください。'
            "
          />
        </v-tooltip>
      </v-flex>
    </v-layout>
  </AppForm>
</template>

<script>
export default {
  props: {
    delivery: {
      type: Object,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    showHelp: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: Boolean,
  },
  computed: {
    rules() {
      return {
        greaterThanZero: value =>
          Number(value) > 0 || '0より上の数値を入力して下さい',
      }
    },
  },
}
</script>
<style scoped>
.error-message {
  color: red;
  white-space: pre-wrap;
}
</style>
